import { render, staticRenderFns } from "./CatalogDialog.vue?vue&type=template&id=204ef55c&scoped=true&"
import script from "./CatalogDialog.vue?vue&type=script&lang=js&"
export * from "./CatalogDialog.vue?vue&type=script&lang=js&"
import style0 from "./CatalogDialog.vue?vue&type=style&index=0&id=204ef55c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ef55c",
  null
  
)

export default component.exports